var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"type":"danger"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(_vm.showIcon)?_c('IconWarning',{attrs:{"size":"lg"}}):_vm._e()]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }